function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.86365 18H29.1363C29.8863 18 30.4999 17.3769 30.5 16.6154V1.38463C30.5 0.623092 29.8864 0 29.1364 0H1.86365C1.11365 0 0.5 0.623092 0.5 1.38463V16.6154C0.5 17.3769 1.11365 18 1.86365 18ZM4.45943 16.7994H26.5395C26.5395 15.2394 27.7815 13.9631 29.2995 13.9631V4.0358C27.7815 4.0358 26.5395 2.75945 26.5395 1.19945H4.45943C4.45943 2.75945 3.21745 4.0358 1.69945 4.0358V13.9631C3.21745 13.9631 4.45943 15.2394 4.45943 16.7994Z",
  fill: "#023365"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1378 9.27342C21.1378 12.8059 18.6001 15.6045 15.5451 15.6045C12.4902 15.6045 9.95244 12.8059 9.95244 9.27342C9.95244 5.74096 12.4902 2.94231 15.5451 2.94231C18.6001 2.94231 21.1378 5.74096 21.1378 9.27342Z",
  stroke: "#023365",
  strokeWidth: 0.629728
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2859 8.53439H14.809C14.3659 8.53439 14.0706 8.23899 14.0706 7.79597C14.0706 7.35289 14.366 7.05755 14.809 7.05755H17.0243C17.4674 7.05755 17.7628 6.76214 17.7628 6.31913C17.7628 5.87605 17.4674 5.58071 17.0243 5.58071H16.2859C16.2859 5.13763 15.9905 4.84229 15.5475 4.84229C15.1044 4.84229 14.8091 5.13769 14.8091 5.58071C13.5537 5.58071 12.5938 6.54067 12.5938 7.79603C12.5938 9.0514 13.5537 10.0114 14.8091 10.0114H16.286C16.7291 10.0114 17.0244 10.3068 17.0244 10.7498C17.0244 11.1929 16.729 11.4882 16.286 11.4882H14.0707C13.6276 11.4882 13.3322 11.7836 13.3322 12.2266C13.3322 12.6697 13.6276 12.965 14.0707 12.965H14.8091C14.8091 13.4081 15.1045 13.7035 15.5475 13.7035C15.9906 13.7035 16.2859 13.4081 16.2859 12.965C17.5413 12.965 18.5012 12.0051 18.5012 10.7497C18.5012 9.49435 17.5413 8.53439 16.2859 8.53439Z",
  fill: "#023365"
});

const SvgCash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 31,
  height: 18,
  viewBox: "0 0 31 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cash.57410a2d.svg";
export { ForwardRef as ReactComponent };